const MatchActionType = ['VIEWS', 'DIBS', 'MATCH_OFFER', 'FILE_DOWNLOAD'] as const;
export type MatchActionType = (typeof MatchActionType)[number];

export const MatchActionTypeText: { [key in MatchActionType]: string } = {
  VIEWS: '조회',
  DIBS: '찜',
  MATCH_OFFER: '입사제안',
  FILE_DOWNLOAD: '파일 다운로드',
};
